import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, Modal, Switch } from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions, ManagementActions } from '../../../Services/_actions';
import { ProfileObject } from '../../../interfaces/Management.interface.ts';
import { useRecoilState, useRecoilValue } from 'recoil';
import { profileObjAtom } from '../../../Services/_states/Management/management.ts';
import { useNavigate, useParams } from 'react-router-dom';
import { userInformationAtom } from '../../../Services/_states/auth.js';
import ObjectLevelPermission from './ObjectLevelPermission.tsx';
import GeneralUserLevelPermission from './GeneralUserLevelPermission.tsx';
import LoadingButton from '../../Shared/Loading/index.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import ModalForms from '../../Shared/Modals/index.js';
interface CreateEditProfileFormModalProps {
  open: boolean;
  mode: string;
  onClose: (data: any | null) => void;
}

const CreateEditProfileForm: React.FC<CreateEditProfileFormModalProps> = ({
  open,
  mode,
  onClose,
}) => {
  const actions = ManagementActions();
  const { showSnackBar } = useSnackBar();
  const loggedInUser = useRecoilValue(userInformationAtom);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [profileObject, setProfileObject] = useRecoilState<ProfileObject | any>(profileObjAtom);
  // const { mode } = useParams();
  const [contentTypes, setContentTypes] = useState([]);
  const [sessionUI, setSessionUI] = useState({
  days: { label: '0 Days', value: 0 },
  hours: { label: '0 Hours', value: 0 },
  minutes: { label: '0 Minutes', value: 0 },
});

  const [formData, setFormData] = useState<ProfileObject>({
    name: '',
    organisation: '',
    is_standard: false,
    session_timeout: 0, 
  });
  const [validationErrors, setValidationErrors] = useState({
    name: '',
    organisation: '', 
  });

  const getNumber = (val: any) =>
  typeof val === 'object' ? Number(val?.value || 0) : Number(val || 0);

const calculateSessionTimeout = () => {
  return (
    sessionUI.days.value * 24 * 60 +
    sessionUI.hours.value * 60 +
    sessionUI.minutes.value
  );
};


useEffect(() => {
  if ((mode === 'edit' || mode === 'view') && profileObject?.session_timeout) {
    const total = Number(profileObject.session_timeout);

    setSessionUI({
      days: { label: `${Math.floor(total / 1440)} Days`, value: Math.floor(total / 1440) },
      hours: {
        label: `${Math.floor((total % 1440) / 60)} Hours`,
        value: Math.floor((total % 1440) / 60),
      },
      minutes: {
        label: `${total % 60} Minutes`,
        value: total % 60,
      },
    });
  }
}, [profileObject]);




  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    const errors: any = {};

    if (!formData?.name?.trim()) {
      errors.name = 'Profile name is required';
    }

    if (!formData.organisation) {
      errors.organisation = 'Organisation is required';
    }

    setValidationErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (mode === 'edit') {
        try {
          let updateObj = {
            ...formData,
            session_timeout: calculateSessionTimeout(),
            organisation: formData?.organisation?.organisation_id,
          };
          const res: any = await actions.updateProfile(updateObj, updateObj?.id);
          if (res?.status === 200) {
            showSnackBar('Profile Updated successfully.', 'success');
            // navigate("/r/management/profile-list/");
            onClose({ ...formData });
          }
          setIsLoading(false);
        } catch (error) {
          showSnackBar('An error occurred while Updating the profile.', 'error');
        }
      } else {
        let generalUserPermission: any = [];
        for (let id in loggedInUser?.profile?.general_user_permission) {
          let row: any = { ...loggedInUser?.profile?.general_user_permission[id] };
          delete row['id'];
          row['is_allowed'] = '';
          generalUserPermission.push(row);
        }
        let updateObj = {
          ...formData,
          session_timeout: calculateSessionTimeout(),
          general_user_permission: generalUserPermission,
          organisation: formData?.organisation?.organisation_id,
        };
        try {
          const res = await actions.createProfile(updateObj);
          if (res?.status === 200) {
            setProfileObject({ ...res?.data?.data });
            let profileData = { ...res?.data?.data };

            for (var x in contentTypes) {
              var contentType: { model: string; id: any } = contentTypes[x];

              var object_level_permission1 = {
                name: contentType?.model?.toUpperCase(),
                content_type: contentType?.id,
                profile: profileData?.id,
              };
              let objRes: any = await actions.createObjectLevelPermission(object_level_permission1);
              if (!profileData?.object_level_permission)
                profileData['object_level_permission'] = [];
              profileData = {
                ...profileData,
                object_level_permission: [
                  ...profileData?.object_level_permission,
                  { ...objRes?.data?.data },
                ],
              };
            }
            setProfileObject({ ...profileData });
            setIsLoading(false);
            onClose({ ...profileData });
            showSnackBar('Profile Created successfully.', 'success');
            navigate('/r/management/profile-permissions/edit');
          }
        } catch (error) {
          showSnackBar('An error occurred while Updating the profile.', 'error');
        }
      }
    }
    setIsLoading(false);
  };
  const fetchContents = async () => {
    try {
      let res = await actions.getContentTypes();
      if (res?.status === 200) {
        setContentTypes(res?.data || []);
      }
    } catch (error) {
      showSnackBar('An error occurred while fetching api.', 'error');
      throw error;
    }
  };

  // useEffect(() => {
  //   if (organisationList?.length === 1) {
  //     setFormData({
  //       ...profileObject,
  //       organisation: { ...organisationList[0], label: organisationList[0]?.name },
  //       is_standard: profileObject?.is_standard,
  //       name: profileObject?.name,
  //     });
  //   };
  // }, [organisationList])

  useEffect(() => {
    fetchContents();
  }, []);

  useEffect(() => {
    if (mode === 'edit' || mode === 'view') {
      if (!profileObject?.id) {
        navigate(-1);
      }
      setFormData({
        ...profileObject,
        // organisation: { ...profileObject?.organisation, label: profileObject?.organisation?.name },
        // is_standard: profileObject?.is_standard,
        // name: profileObject?.name,
      });
    }
  }, []);

  return (
    <>
      <ModalForms
        show={open}
        handleClose={() => {
          onClose(null);
        }}
        modalHeader={`${mode === 'edit' ? 'Update' : mode === 'view' ? 'View' : 'Create'} Profile`}
        modalBody={
          <>
            <OrganisationDropdown
              label={
                <Typography component="span">
                  Organization <span style={{ color: 'red' }}>*</span>
                </Typography>
              }
              value={formData?.organisation || null}
              onChange={(data) => {
                setFormData({ ...formData, organisation: data });
                setValidationErrors({ ...validationErrors, organisation: '' });
              }}
              error={!!validationErrors.organisation}
              errorMessage={validationErrors.organisation}
              disabled={mode === 'view'}
            />

            <TextField
              label={
                <Typography component="span">
                  Profile Name <span style={{ color: 'red' }}>*</span>
                </Typography>
              }
              fullWidth
              value={formData?.name || ''}
              onChange={(e) => {
                setFormData({ ...formData, name: e.target.value });
                setValidationErrors({ ...validationErrors, name: '' });
              }}
              sx={{ mb: 2 }}
              margin="dense"
              variant="outlined"
              size="small"
              error={!!validationErrors?.name}
              helperText={validationErrors?.name}
              disabled={mode === 'view'}
            />
            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
              <Typography>Is Standard</Typography>
              <Switch
                checked={formData?.is_standard || false}
                onChange={(e) => {
                  setFormData({ ...formData, is_standard: e.target.checked });
                }}
                inputProps={{ 'aria-label': 'Is Standard Profile' }}
                disabled={mode === 'view'}
              />
            </Box>
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ mb: 1 }}>Session Timeout</Typography>

              <Box display="flex" gap={2}>
               <SearchableDropdown
  label="Days"
  value={sessionUI.days}
  options={[...Array(32)].map((_, i) => ({
    label: `${i} Days`,
    value: i,
  }))}
  onChange={(val) =>
    setSessionUI((prev) => ({ ...prev, days: val }))
  }
  disabled={mode === 'view'}
/>

<SearchableDropdown
  label="Hours"
  value={sessionUI.hours}
  options={[...Array(24)].map((_, i) => ({
    label: `${i} Hours`,
    value: i,
  }))}
  onChange={(val) =>
    setSessionUI((prev) => ({ ...prev, hours: val }))
  }
  disabled={mode === 'view'}
/>

<SearchableDropdown
  label="Minutes"
  value={sessionUI.minutes}
  options={[...Array(60)].map((_, i) => ({
    label: `${i} Minutes`,
    value: i,
  }))}
  onChange={(val) =>
    setSessionUI((prev) => ({ ...prev, minutes: val }))
  }
  disabled={mode === 'view'}
/>

              </Box>
            </Box>
          </>
        }
        modalFooter={
          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                onClose(null);
              }}
              disabled={mode === 'view'}
            >
              Cancel
            </Button>
            {mode !== 'view' && (
              <LoadingButton
                buttonName={mode === 'edit' ? 'Update' : 'Create'}
                variant="contained"
                onClickButton={(e: React.FormEvent<HTMLFormElement>) => handleSubmit(e)}
                isLoading={isLoading}
                size="small"
              />
            )}
          </Box>
        }
      />
    </>
  );
};
export default CreateEditProfileForm;
